import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import * as Cookies from 'js-cookie'
import { useDispatch } from 'react-redux'

import { getAppRoute } from 'helpers/application'
import { showModal } from 'components/Atoms/Modal/actions'
import withSignIn from 'hocs/withSignIn'

import SignIn from './Screen'

const SignInHOC = Component => {
  const Wrapper = props => {
    const router = useRouter()
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(true)

    const {
      apple_login_cancelled: appleLoginCanceled,
      application,
      redirectTo,
      auth_token: authenticationToken,
    } = router.query

    useEffect(() => {
      if (!router.isReady) return

      const clientSideInit = async () => {
        const accessToken = Cookies.get('citifyd_access_token')
        const payBySignageFlow = Cookies.get('pay_by_signage_flow')
        const appleLoginRedirect = Cookies.get('citifyd_apple_login_redirect')

        if (payBySignageFlow && appleLoginRedirect) {
          Cookies.set('appleAuthToken', authenticationToken, {
            path: '/',
          })

          router.replace(appleLoginRedirect)

          return
        }

        if (
          !accessToken &&
          !authenticationToken &&
          (!appleLoginCanceled || appleLoginCanceled === 'true')
        ) {
          dispatch(
            showModal({
              childProps: {
                redirectTo: redirectTo || {
                  as: `${getAppRoute(application, 'as')}/my-passes`,
                  url: `${getAppRoute(application, 'url')}/my-passes`,
                },
              },
              modalType: 'signIn',
            })
          )
        } else if (accessToken) {
          const homePath = `${getAppRoute(application, 'url')}/`

          router.replace(homePath)
        }

        setIsLoading(false)
      }

      clientSideInit()
    }, [
      router.isReady,
      router.query,
      application,
      authenticationToken,
      appleLoginCanceled,
      dispatch,
      redirectTo,
      router,
    ])

    if (isLoading) {
      return null
    }

    return (
      <Component
        {...props}
        appleLoginCanceled={appleLoginCanceled}
        authenticationToken={authenticationToken}
      />
    )
  }

  Wrapper.propTypes = {
    authenticationToken: PropTypes.string,
    router: PropTypes.object,
  }

  return Wrapper
}

export default withSignIn(SignInHOC(SignIn))
